import Peer from 'peerjs';
import { SharedService } from "../services/shared.service";

export class CallService {

  public peer: any;
  public call: any;
  public myStream: any;
  public peerStream: any;
  public audio: boolean = true;
  public video: boolean = true;
  public faceUser: boolean = true;
  public myVideo: any;
  public peerVideo: any;
  public awaitingCall: boolean = false;
  public callAnswered: boolean = false;
  public callAccepted: boolean = false;
  public peerJsServer: any;
  public examRoom: any;
  public peerId: any;
  public connection: any;

  constructor() {

  }

  initialize(peerId, peerJsServer, examRoom, myVideo, peerVideo) {
    this.peerId = peerId;
    this.peerJsServer = peerJsServer;
    this.examRoom = examRoom;
    this.myVideo = myVideo;
    this.peerVideo = peerVideo;

    const minDelay = 1; // Minimum delay in milliseconds
    const maxDelay = 1000; // Maximum delay in milliseconds
    const randomDelay = Math.random() * (maxDelay - minDelay) + minDelay;

    setTimeout(() => {
      // Your code to execute after the random delay
      console.log('Action executed after a random delay');

      this.createPeer().then(() => {
        this.faceUser = true;
        this.peer.on('open', (id) => {
          console.log('Getting UserMedia...');
          navigator.mediaDevices.getUserMedia({video: { facingMode: this.faceUser ? 'user' : 'environment' }, audio: true}).then((myStream) => {
            console.log('UserMedia obtained... ' + myStream);
            this.videoStreamStarted();
            this.myVideo.nativeElement.srcObject = myStream;
            this.myVideo.nativeElement.play();
            //this.myVideo = myVideo;
            this.myStream = myStream;

            this.awaitingCall = false;
            this.awaitCall();

            this.makeCall();

          }).catch((err) => {
            console.error('Failed to get local stream', err);
          });
        });
      });
    }, randomDelay);


  }

  async createPeer() {
    console.log('Creating peer... ' + this.peerId);

    let promise = new Promise((resolve, reject) => {
      if(this.peer) {
        this.peer.destroy();
      }

      if(this.peerJsServer != null) {
        this.peer = new Peer(this.peerId,
          {
            host: this.peerJsServer.host,
            port: this.peerJsServer.port,
            path: this.peerJsServer.path
          });
      } else {

        //alert(this.examRoom.sharedService.turnServerDetails.stun_url);

        this.peer = new Peer(this.peerId,
          {config: {'iceServers': [
              {
                  "urls": this.examRoom.sharedService.turnServerDetails.stun_url
              },
              {
                  "urls": this.examRoom.sharedService.turnServerDetails.turn_url,
                  "username": this.examRoom.sharedService.turnServerDetails.username,
                  "credential": this.examRoom.sharedService.turnServerDetails.credential
              }
          ]}
        });
      }

      this.peer.on('error', (err) => {
        console.error('Error with peer...' + err.type);
        this.peerStream = null;
        if(err.type == 'peer-unavailable') {
          this.awaitingCall = false;
          this.awaitCall();
        }
      });

      console.log('Peer created... ' + this.peerId);

      return resolve;

    });

  }

  makeCall() {


    if(this.examRoom.sharedService.currentUser.type_id == 1) {
      console.log('Establishing connection... ' + this.examRoom.appointment.owner_data.peer_id);
      this.connection = this.peer.connect(this.examRoom.appointment.owner_data.peer_id);
    } else if(this.examRoom.sharedService.currentUser.type_id == 2) {
      console.log('Establishing connection... ' + this.examRoom.appointment.veterinarian_data.peer_id);
      this.connection = this.peer.connect(this.examRoom.appointment.veterinarian_data.peer_id);
    }

    if(this.examRoom.sharedService.currentUser.type_id == 1) {
      console.log('Establishing call... ' + this.examRoom.appointment.owner_data.peer_id);
      this.call = this.peer.call(this.examRoom.appointment.owner_data.peer_id, this.myStream);
    } else if(this.examRoom.sharedService.currentUser.type_id == 2) {
      console.log('Establishing call... ' + this.examRoom.appointment.veterinarian_data.peer_id);
      this.call = this.peer.call(this.examRoom.appointment.veterinarian_data.peer_id, this.myStream);
    }
    //this.call = call;
    this.call.on('stream', (peerStream) => {
      this.callAnswered = true;
      console.log('Call answered... ' + this.examRoom.appointment.owner_data.peer_id);

      // Show stream in some <video> element.
      this.peerVideo.nativeElement.srcObject = peerStream;
      this.peerVideo.nativeElement.play();
      //this.peerVideo = peerVideo;
      this.peerStream = peerStream;
    });
    this.call.on('close',() => {
      console.log('Call stopped and connection closed...');
      this.peerStream = null;
      this.awaitingCall = false;
      this.awaitCall();
    });
    this.call.on('error',(error) => {
      console.log('Call error: ' + error);
      this.peerStream = null;
      this.call.close();
      this.awaitingCall = false;
      this.awaitCall();
    });
    // this one works
    this.connection.on('close', () => {
        console.log("Connection closed... Stopping call...");
        this.awaitingCall = false;
        this.call.close();
        this.peerStream = null;
        this.awaitCall();
    });


  }

  awaitCall() {
    if(this.awaitingCall)
      return;

    this.awaitingCall = true;

    console.log('Awaiting call...');

    this.peer.on('connection', (connection) => {
      this.connection = connection;

      this.peer.on('call', (call) => {
        this.call = call;
        this.call.answer(this.myStream); // Answer the call with an A/V stream.
        this.call.on('stream', (peerStream) => {
          console.log('Call accepted... ');
          // Show stream in some <video> element.
          this.peerVideo.nativeElement.srcObject = peerStream;
          this.peerVideo.nativeElement.play();
          //this.peerVideo = peerVideo;
          this.peerStream = peerStream;
        });
        this.call.on('close',() => {
          console.log('Call stopped and connection closed...');
          this.peerStream = null;
          this.awaitingCall = false;
          this.awaitCall();
        });
        this.call.on('error',(error) => {
          console.log('Call error: ' + error);
          this.peerStream = null;
          this.awaitingCall = false;
          this.call.close();
          this.awaitCall();
        });
      });
      // this one works
      this.connection.on('close', () => {
          console.log("Connection closed... Stopping call...");
          this.awaitingCall = false;
          this.call.close();
          this.awaitCall();
      });
    });
  }

  destroy() {
    try {
      this.awaitingCall = false;
      this.call.close();
      this.connection.close();
      this.peer.destroy();
      console.log('Connections closed...');
      this.audio = true;
      this.video = true;
      this.faceUser = true;
      return this.peer.destroyed;
    } catch (error) {
      //connection doesn't exist
      return false;
    }

  }

  // stop both mic and camera
  stopBothVideoAndAudio() {
    try {
      console.log('Stopping both video and audio...');
      this.myStream.getTracks().forEach(function(track) {
          if (track.readyState == 'live') {
              track.stop();
              console.log('Track stopped.')
          }
      });
      console.log('Stopped both video and audio...');

      this.myStream = null;

      this.videoStreamStopped();
    } catch (error) {
      //tracks don't exist
    }
  }

  async toggleCamera() {
    // Stop the tracks
    const tracks = this.myStream.getTracks();
    tracks.forEach(track => track.stop());

    this.faceUser = !this.faceUser;

    try {
      // Provide new options
      let myStream = await navigator.mediaDevices.getUserMedia({video: { facingMode: this.faceUser ? 'user' : 'environment' }, audio: true});
      console.log('UserMedia obtained... ' + myStream);

      this.myStream = myStream;


      this.call.peerConnection.getSenders()[1].replaceTrack(this.myStream.getVideoTracks()[0]);
      this.call.peerConnection.getSenders()[0].replaceTrack(this.myStream.getAudioTracks()[0]);

    } catch (error) {
      console.error('Failed to get local stream... ' + error);
    }

    this.myVideo.nativeElement.srcObject = this.myStream;
    this.myVideo.nativeElement.play();

  }

  toggleAudio() {
    this.myStream.getAudioTracks()[0].enabled = !(this.myStream.getAudioTracks()[0].enabled);
    this.audio = this.myStream.getAudioTracks()[0].enabled;
    console.log('Toggled audio... ' + this.audio);
  }

  toggleVideo() {
    this.myStream.getVideoTracks()[0].enabled = !(this.myStream.getVideoTracks()[0].enabled);
    this.video = this.myStream.getVideoTracks()[0].enabled;
    console.log('Toggled video... ' + this.video);
  }

  videoStreamStarted() {

    this.examRoom.sharedService.connection.requestHttpPostCapacitor(this.examRoom.sharedService.connection.generateRequestUrl('/video_stream_started'),
    {
      auth_user_id: this.examRoom.sharedService.currentUser.user_id,
      remember_token: this.examRoom.sharedService.currentUser.remember_token,
      appointment_id: this.examRoom.appointment.appointment_id
    }, function(response, component) {

      //alert(JSON.stringify(response.message));

      var data = JSON.parse(response.data);

      if(data.code == 200){
        console.log('Server notified of video stream starting...');
        console.log(response);

      } else if(data.code == 501) {
        //component.sharedService.presentToast(data.message, 'middle', 3000, 'toast');
      } else {
        //show error notification
        console.log(response);
      }
    }, function(err, component) {
      //alert(JSON.stringify(err));
      console.error('Error notifying server of video stream starting... ' + JSON.stringify(err));

    }, this);
  }

  videoStreamStopped() {

    this.examRoom.sharedService.connection.requestHttpPostCapacitor(this.examRoom.sharedService.connection.generateRequestUrl('/video_stream_stopped'),
    {
      auth_user_id: this.examRoom.sharedService.currentUser.user_id,
      remember_token: this.examRoom.sharedService.currentUser.remember_token,
      appointment_id: this.examRoom.appointment.appointment_id
    }, function(response, component) {

      //alert(JSON.stringify(response.message));

      var data = JSON.parse(response.data);

      if(data.code == 200){
        console.log('Server notified of video stream stopping...');
        console.log(response);

      } else if(data.code == 501) {
        //component.sharedService.presentToast(data.message, 'middle', 3000, 'toast');
      } else {
        //show error notification
        console.log(response);
      }
    }, function(err, component) {
      //alert(JSON.stringify(err));
      console.error('Error notifying server of video stream stopping... ' + JSON.stringify(err));

    }, this);
  }



}
